/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AgencyAutocompleteResponseItem,
    AgencyAutocompleteResponseItemFromJSON,
    AgencyAutocompleteResponseItemFromJSONTyped,
    AgencyAutocompleteResponseItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AgencyAutocompleteResponseItemAutocompleteResult
 */
export interface AgencyAutocompleteResponseItemAutocompleteResult {
    /**
     * 
     * @type {Array<AgencyAutocompleteResponseItem>}
     * @memberof AgencyAutocompleteResponseItemAutocompleteResult
     */
    results?: Array<AgencyAutocompleteResponseItem> | null;
    /**
     * 
     * @type {number}
     * @memberof AgencyAutocompleteResponseItemAutocompleteResult
     */
    numberOfItems?: number;
}

export function AgencyAutocompleteResponseItemAutocompleteResultFromJSON(json: any): AgencyAutocompleteResponseItemAutocompleteResult {
    return AgencyAutocompleteResponseItemAutocompleteResultFromJSONTyped(json, false);
}

export function AgencyAutocompleteResponseItemAutocompleteResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgencyAutocompleteResponseItemAutocompleteResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(AgencyAutocompleteResponseItemFromJSON)),
        'numberOfItems': !exists(json, 'numberOfItems') ? undefined : json['numberOfItems'],
    };
}

export function AgencyAutocompleteResponseItemAutocompleteResultToJSON(value?: AgencyAutocompleteResponseItemAutocompleteResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(AgencyAutocompleteResponseItemToJSON)),
        'numberOfItems': value.numberOfItems,
    };
}


